<figure class="mpp-user-avatar__figure" *ngIf="url">
  <img [src]="url" alt=" " class="mpp-user-avatar__img">
</figure>

<div class="mpp-user-avatar__initials" *ngIf="name">
  {{ name | mppInitials }}
</div>

<div class="mpp-user-avatar__icon icon icon-person-filled"></div>
